export default __webpack_public_path__ + "static/Stores-db81cd16a39c884a73653b850d76ff2f.jpg";